export const vrLayers = {
	normal: 0,
	noRaycast: 1,
};